import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    FormGroup,
    FormControlLabel,
    Switch,
} from "@mui/material";

import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { DaemonTab } from "./DaemonTab";
import { DaemonAITab } from "./DaemonAITab";

import classes from "./HaasSection.module.css";
import { useHaasSelector } from "../../../../Services/Redux/selectors/aiServiceDetailsSelector";
import { isHostingAvailable } from "../../../../Components/HaaS/Components/HostingUnavailable";

export const TAB_KEYS = {
    daemon: "daemon",
    daemonAI: "daemonAI",
};

const isHaasAvailable = isHostingAvailable();

export const HaasSection = ({
    isActivated,
    setIsActivated,
    currentHaasSectionTab,
    setCurrentHaasSectionTab,
}) => {
    const serviceDeployments = useSelector((state) => state.aiServiceDetails?.deployments);
    const { hasDaemon, hasService, hasDaemonOrService } = useHaasSelector();

    const [isFreezed, setIsFreezed] = useState(false);

    useEffect(() => {
        if (hasDaemonOrService) {
            setIsActivated(true);
            setIsFreezed(true);
        }

        if (!isHaasAvailable) {
            setIsFreezed(true);
        }
    }, [hasDaemonOrService, setIsActivated]);

    return (
        <section className={classes.root}>
            <p className={classes.description}>
                If you want to take full advantage of automated Daemon and AI service deployment and
                updates, please activate the Hosting-as-a-Service section. Full details and a guide
                to using HaaS can be found&nbsp;
                <a
                    href="https://dev.singularitynet.io/docs/products/DecentralizedAIPlatform/HaaS/"
                    rel="noopener noreferrer"
                    target="_blank"
                >
                    here
                </a>
                .
            </p>
            <Accordion
                expanded={isActivated}
                disableGutters
                elevation={0}
                sx={{
                    borderRadius: 4,
                    background:
                        "linear-gradient(177deg, #2196F3 0%, #512DA8 100%), linear-gradient(157deg, #020035 0%, #020035 16.5%, #060071 84.24%)",
                }}
            >
                <AccordionSummary
                    sx={{
                        minHeight: 50,
                        cursor: "default !important",
                        padding: "0",
                        "& .MuiAccordionSummary-content": {
                            margin: "0",
                            // cursor: 'default',
                        },
                    }}
                >
                    <div className={classes.summary}>
                        <div>Hosting-as-a-Service</div>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={isActivated}
                                        disabled={isFreezed}
                                        onChange={(event) => {
                                            setIsActivated(event.target.checked);
                                        }}
                                        sx={{
                                            "& .MuiSwitch-track": {
                                                backgroundColor: "rgba(255, 255, 255)",
                                            },
                                            "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                                                {
                                                    backgroundColor: "rgba(255, 255, 255)",
                                                },
                                        }}
                                    />
                                }
                                label="Activate"
                                labelPlacement="start"
                                sx={{
                                    "& .MuiFormControlLabel-label": {
                                        color: "var(--color-custom-white)",
                                    },
                                }}
                            />
                        </FormGroup>
                    </div>
                </AccordionSummary>
                <AccordionDetails
                    sx={{
                        padding: "0",
                    }}
                >
                    <div className={classes.details}>
                        <TabContext value={currentHaasSectionTab}>
                            <TabList
                                onChange={(_, value) => {
                                    setCurrentHaasSectionTab(value);
                                }}
                                aria-label="lab API tabs example"
                                sx={{
                                    "& .MuiTabs-indicator": {
                                        backgroundColor: "var(--color-custom-white)",
                                    },
                                }}
                            >
                                <Tab
                                    label="Daemon"
                                    value={TAB_KEYS.daemon}
                                    sx={{
                                        textTransform: "unset",
                                        color: "var(--color-accent-dark-grey)",
                                        "&.Mui-selected": {
                                            color: "var(--color-custom-white)",
                                        },
                                    }}
                                />
                                <Tab
                                    label="Daemon + AI Service"
                                    value={TAB_KEYS.daemonAI}
                                    sx={{
                                        textTransform: "unset",
                                        color: "var(--color-accent-dark-grey)",
                                        "&.Mui-selected": {
                                            color: "var(--color-custom-white)",
                                        },
                                    }}
                                />
                            </TabList>
                            <TabPanel value={TAB_KEYS.daemon} keepMounted sx={{ padding: "0" }}>
                                <DaemonTab
                                    hasDaemon={hasDaemon}
                                    daemon={serviceDeployments.daemon}
                                />
                            </TabPanel>
                            <TabPanel value={TAB_KEYS.daemonAI} keepMounted sx={{ padding: "0" }}>
                                <DaemonAITab
                                    hasService={hasService}
                                    deployments={serviceDeployments}
                                />
                            </TabPanel>
                        </TabContext>
                    </div>
                </AccordionDetails>
            </Accordion>
        </section>
    );
};
